<template>
  <div>
    <el-dialog
      title="投图"
      width="80%"
      :append-to-body="false"
      :modal-append-to-body="false"
      :before-close="handleClose"
      :visible="true"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <div class="pick-date">
          <div class="label">投图日期</div>
          <div class="date-select">
            <datePicker
              @changeMonth="getNewDate"
              @getMarkDate="getMarkDate"
              :markDate="markDate"
            ></datePicker>
          </div>
        </div>
        <div class="pic-list" id="pic-list" v-loadmore="loadMore" :key="picKey">
          <PicTimeline
            @showDetail="openDetailView"
            :imgDateList="imgDateList"
          ></PicTimeline>
          <p v-if="finished && !isSingleDay" class="no-more">没有更多了</p>
        </div>
      </div>
      <div class="dialog-bottom">
        <el-button type="primary" @click="handleClose" size="small"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
    <detail-view
      v-if="showDetailView"
      :currentIndex="0"
      :imgList="[{ url: curViewImgSrc }]"
      @close="closeDetailView"
    ></detail-view>
  </div>
</template>

<script>
import datePicker from "./part/datePicker.vue";
import PicTimeline from "./PicTimeline.vue";
import DetailView from "./DetailView.vue";
import * as Api from "../indexApi.js";

export default {
  name: "throwingPic",
  components: {
    datePicker,
    PicTimeline,
    DetailView,
  },
  data() {
    return {
      finished: false,
      loading: false,
      curViewImgSrc: "",
      markDate: [],
      imgDateList: [],
      showDetailView: false,
      currPageIndex: 0,
      pageSize: 50,
      isSingleDay: false,
      picKey: 0,
    };
  },
  directives: {
    loadmore: {
      bind(el, binding) {
        el.addEventListener("scroll", (e) => {
          if (
            e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <
            10
          ) {
            binding.value();
          }
        });
      },
    },
  },
  methods: {
    loadMore() {
      if (!this.finished && !this.loading) {
        this.getTeacherPicLogPages();
      }
    },
    handleClose() {
      this.$emit("close");
    },
    getNewDate(monthChange, dayChange) {
      console.log(monthChange, dayChange);
      if (monthChange) {
        this.getFileDays(monthChange);
      } else if (dayChange) {
        this.getFilesByDay(dayChange);
      } else {
        this.resetLog();
      }
    },
    resetLog() {
      this.finished = false;
      this.loading = true;
      this.imgDateList = [];
      this.currPageIndex = 0;
      this.getTeacherPicLogPages();
    },
    openDetailView(src) {
      this.showDetailView = true;
      this.curViewImgSrc = src;
    },
    closeDetailView() {
      this.showDetailView = false;
    },
    getFileDays(month) {
      let data = {
        month: month,
      };
      Api.getFileDays(data)
        .then((res) => {
          if (res.errCode == 0) {
            this.markDate = res.data.days;
          }
        })
        .catch((err) => {});
    },
    getFilesByDay(date) {
      let data = {
        date: date,
      };
      this.$loading.show();
      Api.getFilesByDay(data)
        .then((res) => {
          this.picKey++;
          this.$loading.hide();
          this.finished = true;
          this.isSingleDay = true;
          if (res.errCode == 0) {
            let dateItem = {
              date: date,
              hide: false,
              list: res.data.list,
            };
            this.imgDateList = [dateItem];
          }
        })
        .catch((err) => {
          this.$loading.hide();
        });
    },
    getTeacherPicLogPages() {
      this.currPageIndex++;
      let data = {
        curr_page_index: this.currPageIndex,
        page_size: this.pageSize,
      };
      this.loading = true;
      this.$loading.show();
      Api.getTeacherPicLogPages(data)
        .then((res) => {
          this.$loading.hide();
          this.loading = false;
          this.isSingleDay = false;
          if (res.errCode == 0) {
            let pageCount = res.data.pageCount;
            if (this.currPageIndex >= pageCount) {
              this.finished = true;
            }
            let newDateList = res.data.list;
            if (newDateList.length > 0) {
              for (let item of newDateList) {
                this.$set(item, "hide", false);
              }
              let lastDateIndex = this.imgDateList.findIndex(
                (e) => e.date == newDateList[0].date
              );
              console.log("lastDateIndex:" + lastDateIndex);
              if (lastDateIndex > -1) {
                let newList = newDateList[0].list || [];
                this.imgDateList[lastDateIndex].list = [
                  ...this.imgDateList[lastDateIndex].list,
                  ...newList,
                ];
                newDateList.shift();
              }
              this.imgDateList = [...this.imgDateList, ...newDateList];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$loading.hide();
          throw new Error(err);
        });
    },
    getMarkDate(month) {
      this.getFileDays(month);
    },
  },
  mounted() {},
  created() {
    this.resetLog();
    let timeStamp = parseInt(new Date().getTime() / 1000);
    let month = this.format(timeStamp, "YYYY-MM");
    this.getFileDays(month);
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0 !important;
    border-radius: 4px;
    max-width: 8.46rem;
    min-width: 5rem;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__header {
    font-weight: 500;
    color: #202020;
    padding: 0.16rem 0.16rem 0 0.3rem;
  }
}

.dialog-content {
  padding: 0.12rem 0.16rem 0 0.16rem;
}

.pick-date {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  background: #eceef5;

  .label {
    margin-right: 16px;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
  }
}

.pic-list {
  margin-top: 20px;
  margin-left: 16px;
  height: 400px;
  overflow: scroll;
}

.dialog-bottom {
  text-align: right;
  border-top: 1px solid #d3dce6;
  padding: 0.16rem 0.32rem;
  .el-button {
    background: #027bfe;
  }
}
.no-more {
  font-size: 13px;
  color: #ccc;
  text-align: center;
}

@media (max-width: 980px) {
  .dialog-bottom {
    padding: 0.1rem 0.32rem;
  }
}
</style>